import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../store'

// Clean axios instance without interceptors for token validation in router guard
const cleanAxios = axios.create()

import { findProductByUrlName, fetchProductsFromServer } from '../utils/productData'

//forms


import uploadVideo from '@/components/forms/uploadVideo.vue';
//import urgentCareForm from '../components/forms/urgentCareForm.vue';
//import examQuestionnaire from '../components/forms/examQuestionnaire.vue';

import videoExplainer from '../components/forms/videoExplainer.vue';


//import WeightLossFlowTwo from '../components/WeightLoss/WeightLossFlowTwo.vue';
import WeightLossStyle2 from '../components/WeightLoss/WeightLossStyle2.vue';
import WeightLossStyleTwo from '../components/WeightLoss/WeightLossStyleTwo.vue';
import WeightLossCheckoutFlow from '../components/WeightLoss/WeightLossCheckoutFlow.vue';
import weightLossCheckoutV2 from '../components/WeightLoss/weightLossCheckoutV2.vue';
import WeightLossStyleThree from '../components/WeightLoss/WeightLossStyleThree.vue';
import weightLossGoogle from '../components/WeightLoss/weightLossGoogle.vue';
import weightLossGoogleThreePlus from '../components/WeightLoss/weightLossGoogleThreePlus.vue';

import weightLossCheckoutV2Images from '../components/WeightLoss/weightLossCheckoutV2Images.vue';

import upSellPage from '../components/WeightLoss/upSellPage.vue';


import collectPhoneAndBMI from '../components/WeightLoss/collectPhoneAndBMI.vue';

import weightLossPreForm from '../components/WeightLoss/weightLossPreForm.vue';

import glpQuizFiveSteps from '../components/WeightLoss/glpQuizFiveSteps.vue';
import Glp1V4Wizard from '../components/wizards/glp1-v4.vue';
import CheckoutGlp1V4 from '../components/checkouts/Checkout-glp1-v4.vue';
import Glp1V5Wizard from '../components/wizards/glp1-v5.vue';
import CheckoutGlp1V5 from '../components/checkouts/Checkout-glp1-v5.vue';
import KlarnaReturn from '../components/checkouts/KlarnaReturn.vue';

// New Quiz V1
const NewQuizV1 = () => import('@/components/WeightLoss/NewQuizV1.vue');

// New Quiz V2
const NewQuizV2 = () => import('@/components/NewQuizV2/NewQuizV2.vue');

// Weight Loss Quiz
const WeightLossQuiz = () => import('@/components/WeightLossQuiz/WeightLossQuiz.vue');

import reportPage from '../components/WeightLoss/reportPage.vue';
import choosePlan from '../components/WeightLoss/choosePlan.vue';


//sorry page
import leadDisqualified from '../components/common/leadDisqualified.vue';

import prescriptionThanks from '../components/WeightLoss/WeightLossAfterCheckout.vue';
import verifyPhone from '../components/WeightLoss/verifyPhone.vue';
import verifyAddress from '../components/common/verifyAddress.vue';


import checkoutWeightLoss from '../components/checkouts/checkoutWeightLoss.vue';
import checkoutWeightLossV2 from '../components/checkouts/checkoutWeightLossV2.vue';


import urgentCareCheckout from '../components/urgentCare/urgentCareNewCheckout.vue';
import urgentCareExplanation from '../components/urgentCare/urgentCareStart.vue'; 
import urgentCareEnd from '../components/urgentCare/urgentCareEnd.vue'; 
import urgentCareFormNew from '../components/urgentCare/urgentCareFormNew.vue'; 


import checkoutCallCenter from '../components/checkouts/checkoutCallCenter.vue';

import checkoutFlow from '../components/checkouts/checkoutFlow.vue';
import UpgradeCheckout from '../components/checkouts/UpgradeCheckout.vue';


//Tdee Report
import tdeeIntakeForm from '../components/tdee/tdeeIntakeForm.vue';
import reportTdee from '../components/tdee/reportTdee.vue';

import adjustDoases from '@/components/forms/AdjustDoases.vue';
import prescriptionView from '@/components/forms/prescriptionView.vue';

//auth
import LoginPage from '../components/auth/LoginPage.vue';
import ResetPassword from '../components/auth/ResetPassword.vue'
import ForgotPassword from '../components/auth/ForgotPassword.vue'
import ommUsers from '../components/auth/ommUsers.vue'

// New dashboard layout (V1)
const DashboardShell = () => import('@/components/dashboard/layout/DashboardShell.vue')
const DashboardOverview = () => import('@/components/dashboard/overview/DashboardOverview.vue')
const OrdersPage = () => import('@/components/dashboard/orders/OrdersPage.vue')
const MessagesPage = () => import('@/components/dashboard/messages/MessagesPage.vue')
const ProfilePage = () => import('@/components/dashboard/profile/ProfilePage.vue')
const BillingPage = () => import('@/components/dashboard/billing/BillingPage.vue')
const ReferralsPage = () => import('@/components/dashboard/referrals/ReferralsPage.vue')
const MedicalFormPage = () => import('@/components/dashboard/medical-form/MedicalFormPage.vue')
const MetabolicReportPage = () => import('@/components/dashboard/metabolic/MetabolicReportPage.vue')
const UpgradePage = () => import('@/components/dashboard/upgrade/UpgradePage.vue')
const MedicalCheckinPage = () => import('@/components/dashboard/checkin/MedicalCheckin.vue')
const VerifyAddressPage = () => import('@/components/dashboard/verify-address/VerifyAddress.vue')
//product
import productTemplate from '../components/product/productTemplate.vue'
import productTemplate2 from '../components/product/productTemplate2.vue'

//dashboard
const StorePage = () => import('@/components/dashboard/store/StorePage.vue')
const StoreCheckoutPage = () => import('@/components/dashboard/store/CheckoutPage.vue')

const StoreProductTemplate = () => import('@/components/dashboard/store/ProductTemplate.vue')
const StoreProductTemplate2 = () => import('@/components/dashboard/store/ProductTemplate2.vue')

import reviewPage from '../components/common/reviewPage.vue';
import reviewThanksGood from '../components/common/reviewThanksGood.vue';
import reviewThanksBad from '../components/common/reviewThanksBad.vue';
import UnsubscribePage from '../components/common/UnsubscribePage.vue';

import reshippingRequest from '@/components/reshipping/reshippingRequest.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  hash: false,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved scroll position (like after navigating back), use it
    if (savedPosition) {
      return savedPosition;
    } else {
      // Otherwise, scroll to the top
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'WeightLossFlowTwoHome',
      component: WeightLossStyle2,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/pre-qualify',
      name: 'WeightLossStyleTwo',
      component: WeightLossStyleTwo,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/pre-qualify-v2',
      name: 'WeightLossStyleThree',
      component: WeightLossStyleThree,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp1',
      name: 'WeightLossCheckoutFlow',
      component: WeightLossCheckoutFlow,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp1/klarna-return',
      name: 'KlarnaReturnGlp1',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp1/:name/klarna-return',
      name: 'KlarnaReturnGlp1Google',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp1/:name',
      name: 'weightLossGoogle',
      component: weightLossGoogle,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/deals/:name/:terms',
      name: 'weightLossGoogleThreePlus',
      component: weightLossGoogleThreePlus,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/deals/:name/:terms/klarna-return',
      name: 'KlarnaReturnDeals',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp1-v3',
      name: 'glpQuizFiveSteps',
      component: glpQuizFiveSteps,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp1-v3/klarna-return',
      name: 'KlarnaReturnGlp1V3',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp-signup',
      name: 'weightLossCheckoutV2Images',
      component: weightLossCheckoutV2Images,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/pre-form',
      name: 'weightLossPreForm',
      component: weightLossPreForm,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp-signup/klarna-return',
      name: 'KlarnaReturnGlpSignup',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/new-quiz-v1',
      name: 'newQuizV1',
      component: NewQuizV1,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/new-quiz-v2',
      name: 'newQuizV2',
      component: NewQuizV2,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-quiz',
      name: 'weightLossQuiz',
      component: WeightLossQuiz,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/personalized-protocol',
      name: 'upSellPage',
      component: upSellPage,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/glp1-v2',
      name: 'weightLossCheckoutV2',
      component: weightLossCheckoutV2,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/glp1-v2/klarna-return',
      name: 'KlarnaReturnGlp1V2',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/get-started',
      name: 'glp1V4Wizard',
      component: Glp1V4Wizard,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/get-started/checkout/:cart_id',
      name: 'CheckoutGlp1V4',
      component: CheckoutGlp1V4,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/get-started/checkout/:cart_id/klarna-return',
      name: 'KlarnaReturnV4',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/start',
      name: 'glp1V5Wizard',
      component: Glp1V5Wizard,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/start/checkout/:cart_id',
      name: 'CheckoutGlp1V5',
      component: CheckoutGlp1V5,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/start/checkout/:cart_id/klarna-return',
      name: 'KlarnaReturn',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/urgent-care',
      name: 'urgentCareCheckout',
      component: urgentCareCheckout,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/urgent-care-start/:orderId',
      name: 'urgentCareExplanation',
      component: urgentCareExplanation,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/urgent-care/:orderId',
      name: 'urgentCareFormNew',
      component: urgentCareFormNew,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/urgent-care-thanks',
      name: 'urgentCareEnd',
      component: urgentCareEnd,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/replacement-request',
      name: 'reshippingRequest',
      component: reshippingRequest,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },  
    {
      path: '/meeting-steps/:id',
      name: 'videoExplainer',
      component: videoExplainer,
      meta: {
        requiresAuth: true,
        guest: true
      }
    },
    {
      path: '/weight-loss-report',
      name: 'reportPage',
      component: reportPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-plan',
      name: 'choosePlan',
      component: choosePlan,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    { 
      path: '/medical-form/:id',
      name: 'FormLoader',
      redirect: to => ({
        path: `/home/medical-form/${to.params.id}`,
        query: to.query,
        hash: to.hash
      }),
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/verify-phone',
      name: 'verifyPhoneAndEmail',
      component: verifyPhone,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/verify-address',
      name: 'verifyAddress',
      component: verifyAddress,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/calorie-intake',
      name: 'tdeeIntakeForm',
      component: tdeeIntakeForm,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    { 
      path: '/review/:userId',
      name: 'reviewPage',
      component: reviewPage,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    { 
      path: '/review-thanks',
      name: 'reviewThanksGood',
      component: reviewThanksGood,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    { 
      path: '/feedback-thanks',
      name: 'reviewThanksBad',
      component: reviewThanksBad,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/calorie-report',
      name: 'reportTdee',
      component: reportTdee,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/prescription/:id',
      name: 'prescriptionView',
      component: prescriptionView,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/adjust-doses/:id',
      name: 'adjustDoases',
      component: adjustDoases,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/checkin/:id',
      redirect: to => `/home/checkin/${to.params.id}${to.fullPath.includes('?') ? '?' + to.fullPath.split('?')[1] : ''}`
    },
    {
      path: '/home',
      component: DashboardShell,
      meta: {
        requiresAuth: true,
        guest: false
      },
      children: [
        {
          path: '',
          name: 'HomePage',
          component: DashboardOverview
        },
        {
          path: 'orders',
          name: 'DashboardOrders',
          component: OrdersPage
        },
        {
          path: 'messages',
          name: 'DashboardMessages',
          component: MessagesPage
        },
        {
          path: 'profile',
          name: 'DashboardProfile',
          component: ProfilePage
        },
        {
          path: 'billing',
          name: 'DashboardBilling',
          component: BillingPage
        },
        {
          path: 'referrals',
          name: 'DashboardReferrals',
          component: ReferralsPage
        },
        {
          path: 'medical-form/:orderId',
          name: 'DashboardMedicalForm',
          component: MedicalFormPage
        },
        {
          path: 'metabolic-report',
          name: 'DashboardMetabolicReport',
          component: MetabolicReportPage
        },
        {
          path: 'upgrade',
          name: 'DashboardUpgrade',
          component: UpgradePage
        },
        {
          path: 'upgrade/klarna-return',
          name: 'DashboardUpgradeKlarnaReturn',
          component: () => import('@/components/dashboard/upgrade/KlarnaReturnUpgrade.vue')
        },
        {
          path: 'treatment/change',
          name: 'DashboardChangeTreatment',
          component: () => import('@/components/dashboard/upgrade/ChangeTreatmentPage.vue')
        },
        {
          path: 'checkin/:id',
          name: 'DashboardCheckin',
          component: MedicalCheckinPage
        },
        {
          path: 'verify-address',
          name: 'DashboardVerifyAddress',
          component: VerifyAddressPage
        },
        {
          path: 'treatments',
          name: 'DashboardStore',
          component: StorePage
        },
        {
          path: 'treatments/checkout',
          name: 'DashboardStoreCheckout',
          component: StoreCheckoutPage
        },
      ]
    },
    // Store product templates (loaded in iframe modal)
    {
      path: '/store-product/:productName',
      name: 'StoreProductPage',
      component: StoreProductTemplate,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/store-product-2/:productName',
      name: 'StoreProductPage2',
      component: StoreProductTemplate2,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/sorry',
      name: 'leadDisqualified',
      component: leadDisqualified,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/payment/thanks',
      name: 'prescriptionThanks',
      component: prescriptionThanks,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-payment/:cart_id',
      name: 'checkoutWeightLoss',
      component: checkoutWeightLoss,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-payment/:cart_id/klarna-return',
      name: 'KlarnaReturnWeightLoss',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/complete-payment/:cart_id',
      name: 'checkoutWeightLossV2',
      component: checkoutWeightLossV2,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/complete-payment/:cart_id/klarna-return',
      name: 'KlarnaReturnCompletePayment',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/signup/:name',
      name: 'checkoutFlow',
      component: checkoutFlow,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/signup/:name/klarna-return',
      name: 'KlarnaReturnSignup',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/upgrade',
      name: 'UpgradeCheckout',
      component: UpgradeCheckout,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/few-more-details',
      name: 'collectPhoneAndBMI',
      component: collectPhoneAndBMI,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/weightlosspayment/:cart_id',
      name: 'checkoutCallCenter',
      component: checkoutCallCenter,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weightlosspayment/:cart_id/klarna-return',
      name: 'KlarnaReturnCallCenter',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/upload-video/:id',
      name: 'uploadVideo',
      component: uploadVideo,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/password-reset/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/omm',
      name: 'ommUsers',
      component: ommUsers,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/product/:productName',
      name: 'productPage',
      component: productTemplate,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      },
      beforeEnter: async (to, _, next) => {
        try {
          // Ensure products are loaded from cache or server
          const products = await fetchProductsFromServer()
          console.log('Route guard: fetched products count:', products?.length)

          // Now check if product exists
          const product = findProductByUrlName(to.params.productName)
          console.log('Route guard: looking for:', to.params.productName, 'found:', !!product)

          if (product) {
            next()
          } else {
            // Product not found - let component handle it instead of redirecting
            console.warn('Product not found:', to.params.productName)
            next()
          }
        } catch (error) {
          console.error('Error loading products in route guard:', error)
          // Allow navigation anyway, component will handle the error
          next()
        }
      }
    },
    {
      path: '/longevity/:productName',
      name: 'longevityProduct',
      component: productTemplate2,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/unsubscribe/:userId',
      name: 'UnsubscribePage',
      component: UnsubscribePage,
      props: true,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})

router.afterEach(() => {
  store.dispatch('syncWidgetTheme');
});

router.beforeEach(async (to, from, next) => {
  // Auto-login via token in URL (e.g. /?token=xxx from account auto-generation)
  const urlToken = to.query.token;
  if (urlToken) {
    const cleanQuery = { ...to.query };
    delete cleanQuery.token;

    try {
      const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
      const response = await cleanAxios.get(`${apiEndpoint}/api/current-user-details`, {
        headers: { Authorization: `Bearer ${urlToken}` }
      });

      if (response.data.success && response.data.user) {
        store.commit('updateAccessToken', urlToken);
        store.commit('updateUserData', response.data.user);
        if (response.data.shipping) {
          store.dispatch('saveShippingDetails', response.data.shipping);
        }
        if (response.data.referralLink) {
          store.dispatch('setReferralLink', response.data.referralLink);
        }
        return next({ path: '/home', replace: true });
      } else {
        return next({ path: to.path, query: cleanQuery, replace: true });
      }
    } catch (err) {
      return next({ path: to.path, query: cleanQuery, replace: true });
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authToken == null) {
      next({
        path: '/login',
        query: {
          page_ref: to.fullPath,
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router;
